import React, { useState, useEffect } from "react";

const VerticalProgressBar = () => {
  const [scrollPercentage, setScrollPercentage] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercent = (scrollTop / scrollHeight) * 100;
      setScrollPercentage(scrollPercent);
    };

    window.addEventListener("scroll", updateScrollProgress);
    return () => window.removeEventListener("scroll", updateScrollProgress);
  }, []);

  return (
    <div className="fixed top-0 left-2 w-6 h-full flex flex-col items-center justify-center">
  
      <div className="relative h-[80vh] w-2 bg-gray-300 rounded-lg overflow-hidden">
        <div
          className="absolute top-0 left-0 w-2 bg-[#003153] transition-all duration-300"
          style={{ height: `${scrollPercentage}%` }} // Now fills correctly
        ></div>
      </div>

      {/* Percentage Display */}
      <div className="mt-2 text-gray-700 font-semibold text-sm">
        {Math.round(scrollPercentage)}%
      </div>
    </div>
  );
};

export default VerticalProgressBar;
